import PropTypes from 'prop-types';

/**
 * Core
 */
export const urlGenerator = PropTypes.shape({
    route: PropTypes.func.isRequired,
});

export const history = PropTypes.shape({
    listen: PropTypes.func.isRequired,
});

export const intl = PropTypes.shape({
    locale: PropTypes.string.isRequired,
    formatMessage: PropTypes.func.isRequired,
});

export const message = PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
    PropTypes.shape({
        id: PropTypes.string.isRequired,
        defaultMessage: PropTypes.string,
    }),
]);

export const text = PropTypes.oneOfType([message, PropTypes.string]);

export const label = PropTypes.oneOfType([message, PropTypes.node]);

export const statusCode = PropTypes.oneOf([401, 403, 404, 500]);

export const image = PropTypes.shape({
    url: PropTypes.string,
});

export const video = PropTypes.shape({
    id: PropTypes.string,
    mp4: PropTypes.string,
    webm: PropTypes.string,
});

/**
 * Site
 */

export const draw = PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    legal: PropTypes.string,
    startAt: PropTypes.string,
    endAt: PropTypes.string,
    drawingAt: PropTypes.string,
    drawingWeekday: PropTypes.string,
    participationsCount: PropTypes.number,
});

export const draws = PropTypes.arrayOf(draw);

export const drawSection = PropTypes.shape({
    type: PropTypes.string,
    draw,
});

export const stats = PropTypes.shape({});

export const prize = PropTypes.shape({
    type: PropTypes.string,
    category: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    image,
});

export const prizes = PropTypes.arrayOf(prize);

export const user = PropTypes.shape({
    id: PropTypes.string,
    phone: PropTypes.string,
    email: PropTypes.string,
    stats,
    prizes,
});

export const menuItem = PropTypes.shape({
    label,
    url: PropTypes.string,
    external: PropTypes.bool,
    active: PropTypes.bool,
});
export const menuItems = PropTypes.arrayOf(menuItem);

export const page = PropTypes.shape({
    type: PropTypes.string,
    url: PropTypes.string.isRequired,
});

export const block = PropTypes.shape({
    type: PropTypes.string,
});
export const blocks = PropTypes.arrayOf(block);

export const components = PropTypes.objectOf(PropTypes.elementType);

/**
 * Forms
 */
export const errors = PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]);
export const formErrors = PropTypes.objectOf(errors);

export const selectOption = PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
});
export const selectOptions = PropTypes.arrayOf(selectOption);

export const formField = PropTypes.shape({
    value: PropTypes.shape({}),
    name: PropTypes.string,
});
export const formFields = PropTypes.objectOf(formField);

/**
 * Contest
 */

export const location = PropTypes.shape({
    title: PropTypes.string,
    address: PropTypes.string,
    phone: PropTypes.string,
    note: PropTypes.string,
    url: PropTypes.string,
});

export const locations = PropTypes.arrayOf(location);

export const answer = PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
});

export const answers = PropTypes.arrayOf(answer);

export const question = PropTypes.shape({
    id: PropTypes.string,
    category: PropTypes.string,
    title: PropTypes.string,
    label: PropTypes.string,
    image,
    validAnswer: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    ]),
});

export const questions = PropTypes.arrayOf(question);

export const participationAnswer = PropTypes.shape({
    id: PropTypes.string,
    question: PropTypes.string,
    valid: PropTypes.bool,
    validated: PropTypes.bool,
    // eslint-disable-next-line react/forbid-prop-types
    value: PropTypes.any,
});

export const participation = PropTypes.shape({
    gameId: PropTypes.string,
});
export const participations = PropTypes.arrayOf(participation);

export const team = PropTypes.shape({});

export const period = PropTypes.shape({});
export const periods = PropTypes.arrayOf(period);

export const sportGame = PropTypes.shape({
    period: PropTypes.number,
    periods: PropTypes.arrayOf(period),
});
export const sportGames = PropTypes.arrayOf(sportGame);

export const game = PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.oneOf([
        'tinder',
        'nfl',
        'nhl',
        'hangman',
        'memory',
        'quiz',
        'wheel',
        'differences',
        'live_quiz',
        'exam',
    ]),
    category: PropTypes.string,
    title: PropTypes.string,
    participation,
    answers,
    questions,
});
export const games = PropTypes.arrayOf(game);

export const gamesGroup = PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
});
export const gamesGroups = PropTypes.arrayOf(gamesGroup);

export const gameResults = PropTypes.shape({
    title: PropTypes.string,
    subtitle: PropTypes.string,
    prizes: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            name: PropTypes.string,
            description: PropTypes.string,
            image,
        }),
    ),
    delay: PropTypes.number,
    note: PropTypes.string,
    answers: PropTypes.arrayOf(
        PropTypes.shape({
            good: PropTypes.bool,
            image,
        }),
    ),
    extraEntriesCount: PropTypes.number,
});

export const questionsGroup = PropTypes.shape({
    id: PropTypes.string,
    type: PropTypes.string,
    label: PropTypes.string,
    questions,
});

export const questionsGroups = PropTypes.arrayOf(questionsGroup);

export const optin = PropTypes.shape({
    id: PropTypes.string,
    label: PropTypes.string,
});

export const optins = PropTypes.arrayOf(optin);

export const outcome = PropTypes.shape({
    hasPoints: PropTypes.bool,
});

export const contest = PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string,
    phone: PropTypes.string,
    prizes,
    legal: PropTypes.string,
    optins,
    game,
    locations,
    menus: PropTypes.objectOf(menuItems),
    outcome,
    hasPincodes: PropTypes.bool,
});

export const pageUrls = PropTypes.objectOf(PropTypes.string);

export const callToAction = PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    url: PropTypes.string,
});
